<mat-dialog-content>
  <lemon-dialog-header [naytaSuljeRuksi]="false"> Muistutuslaskuja lähetetään </lemon-dialog-header>

  <div style="padding-left: 3em; padding-right: 3em">
    <div style="text-align: center">
      <mat-progress-bar mode="determinate" [value]="(kasiteltyja() / data.laskut.length) * 100"></mat-progress-bar>
      <div style="margin-top: 10px">{{ kasiteltyja() }} / {{ data.laskut.length }}</div>
    </div>
    <div style="margin-top: 30px; margin-bottom: 15px">
      @if (keskeytetaan()) {
        Keskeytetään, odotetaan käsittelyssä olevan laskun valmistumista...
      } @else {
        Älä sulje selainta, muistutusten lähetys on käynnissä.
      }
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <app-primary-button actionId="Peruuta maksumuistutuksien lähetys" (click)="keskeyta()" [disabled]="keskeytetaan()">{{ 'yleiset.peruuta' | translate | async }}</app-primary-button>
</mat-dialog-actions>
